/*
 * Wishlist Orfeo — stockage local (localStorage), sans app externe.
 * Expose window.Wishlist et emet un evenement `wishlist:change` a chaque modification.
 */
(function () {
  const STORAGE_KEY = 'orfeo:wishlist';

  function read() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (handle) {
        return typeof handle === 'string' && handle.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function write(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      // Navigation privee ou quota atteint : l'UI de la page reste a jour malgre tout.
    }
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handles: handles } }));
  }

  const Wishlist = {
    all: read,
    count: function () {
      return read().length;
    },
    has: function (handle) {
      return read().indexOf(handle) !== -1;
    },
    add: function (handle) {
      const handles = read();
      if (handles.indexOf(handle) === -1) {
        handles.unshift(handle);
        write(handles);
      }
      return true;
    },
    remove: function (handle) {
      const handles = read().filter(function (item) {
        return item !== handle;
      });
      write(handles);
      return false;
    },
    toggle: function (handle) {
      return this.has(handle) ? this.remove(handle) : this.add(handle);
    },
  };

  window.Wishlist = Wishlist;

  // Expose pour les cartes injectees apres coup (page Favoris) :
  // sans cela leur coeur reste inactif alors que le produit est en favori.
  Wishlist.refresh = function () {
    refreshButtons();
    refreshCount();
  };

  function refreshButtons() {
    const handles = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      const isActive = handles.indexOf(button.dataset.productHandle) !== -1;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      const label = isActive ? button.dataset.labelRemove : button.dataset.labelAdd;
      if (label) button.setAttribute('aria-label', label);

      // Variante fiche produit : le libelle est aussi visible a l'ecran.
      const labelNode = button.querySelector('[data-wishlist-label]');
      if (labelNode && label) labelNode.textContent = label;
    });
  }

  var dernierTotal = null;

  function refreshCount() {
    const total = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = total;
      node.hidden = total === 0;
    });

    // A la hausse, le pop est declenche par l'ARRIVEE du jeton volant, pas ici :
    // sinon le badge reagirait pendant que le chiffre est encore en vol.
    // A la baisse, un creux bref, pour que le retrait ne soit pas muet.
    if (dernierTotal !== null && total < dernierTotal) {
      document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
        rejouerAnimation(node, 'is-dipped', 330);
      });
    }
    dernierTotal = total;
  }

  function mouvementReduit() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * Rejoue une animation CSS meme si la classe est deja posee : on la retire,
   * on force un reflow, on la remet. Sans le reflow le navigateur regroupe les
   * deux changements et l'animation ne repart pas.
   */
  function rejouerAnimation(el, classe, duree) {
    if (!el || mouvementReduit()) return;
    el.classList.remove(classe);
    void el.offsetWidth;
    el.classList.add(classe);
    clearTimeout(el.__wishlistTimer);
    el.__wishlistTimer = setTimeout(function () {
      el.classList.remove(classe);
    }, duree);
  }

  function refresh() {
    refreshButtons();
    refreshCount();
  }

  function pulserBadges() {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      rejouerAnimation(node, 'is-bumped', 450);
    });
  }

  function visibleAEcran(el) {
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  /**
   * Fait redescendre l'en-tete collant avec le mecanisme natif de Dawn.
   * Le theme est en « on-scroll-up » : en pleine navigation on descend, donc
   * l'en-tete est cache et le coeur d'arrivee invisible. On le revele avec ses
   * propres classes ; son gestionnaire de defilement reprend la main ensuite et
   * le recachera au prochain scroll vers le bas.
   */
  function revelerEnTete() {
    const section = document.querySelector('.section-header');
    // Pas d'en-tete collant configure : on ne force rien.
    if (!section || !document.querySelector('sticky-header')) return false;
    section.classList.add('shopify-section-header-sticky', 'animate');
    section.classList.remove('shopify-section-header-hidden');
    return true;
  }

  /**
   * Envoie un « +1 » du coeur clique vers celui de l'en-tete, en arc.
   * Le badge ne reagit qu'a l'ARRIVEE, pour que le lien de cause a effet se voie.
   * Retombe sur un simple pop des que le vol n'a pas de sens.
   */
  function volerVersHeader(depuis) {
    const cible = document.querySelector('#wishlist-icon-bubble');
    const possible =
      cible &&
      !mouvementReduit() &&
      typeof Element.prototype.animate === 'function' &&
      depuis.getBoundingClientRect().width > 0 &&
      cible.getBoundingClientRect().width > 0; // largeur nulle = icone masquee (mobile)

    if (!possible) return pulserBadges();

    if (visibleAEcran(cible)) return lancerVol(depuis, cible);

    // Cible hors champ : on tente de faire redescendre l'en-tete d'abord.
    if (!revelerEnTete()) return pulserBadges();
    setTimeout(function () {
      if (visibleAEcran(cible)) lancerVol(depuis, cible);
      else pulserBadges();
    }, 320);
  }

  function lancerVol(depuis, cible) {
    const d = depuis.getBoundingClientRect();
    const c = cible.getBoundingClientRect();
    const departX = d.left + d.width / 2;
    const departY = d.top + d.height / 2;
    const dx = c.left + c.width / 2 - departX;
    const dy = c.top + c.height / 2 - departY;

    const jeton = document.createElement('span');
    jeton.className = 'wishlist-fly';
    jeton.setAttribute('aria-hidden', 'true');
    jeton.textContent = '+1';
    jeton.style.left = departX + 'px';
    jeton.style.top = departY + 'px';
    document.body.appendChild(jeton);

    // Le point median remonte : c'est lui qui donne la courbe. On borne la
    // remontee pour que le jeton ne sorte pas par le haut quand la carte cliquee
    // est deja proche du bord superieur (cas frequent apres revelation de l'en-tete).
    const sommet = Math.max(0, Math.min(70, departY + dy * 0.5 - 12));

    const vol = jeton.animate(
      [
        { transform: 'translate(-50%, -50%) scale(0.6)', opacity: 0 },
        { transform: 'translate(-50%, -50%) scale(1)', opacity: 1, offset: 0.15 },
        {
          transform:
            'translate(-50%, -50%) translate(' + dx * 0.5 + 'px, ' + (dy * 0.5 - sommet) + 'px) scale(1.05)',
          opacity: 1,
          offset: 0.55,
        },
        {
          transform: 'translate(-50%, -50%) translate(' + dx + 'px, ' + dy + 'px) scale(0.35)',
          opacity: 0,
        },
      ],
      { duration: 780, easing: 'cubic-bezier(0.4, 0, 0.25, 1)', fill: 'forwards' }
    );

    let termine = false;
    const atterrir = function () {
      if (termine) return;
      termine = true;
      jeton.remove();
      pulserBadges();
    };
    vol.onfinish = atterrir;
    vol.oncancel = atterrir;
    // Filet : en arriere-plan l'animation peut ne jamais se terminer.
    setTimeout(atterrir, 1400);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button || !button.dataset.productHandle) return;
    event.preventDefault();
    event.stopPropagation();

    // toggle() renvoie true quand le produit vient d'etre ajoute :
    // on ne celebre que dans ce sens-la.
    if (Wishlist.toggle(button.dataset.productHandle)) {
      rejouerAnimation(button, 'is-added', 700);
      volerVersHeader(button);
    }
  });

  document.addEventListener('wishlist:change', refresh);

  // Synchronise les autres onglets ouverts.
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
